<template>
  <div @click="showMessage" class="message-con">
    <el-badge :value="mesCount?'new':''" class="item">
      <Icon type="ios-bell" :size="22"></Icon>
    </el-badge>
    <!-- <Tooltip :content="value ? '有未读消息' : '无未读消息'" placement="bottom">
      <Badge :count="value" dot>
        <Icon type="ios-bell" :size="22"></Icon>
      </Badge>
    </Tooltip> -->
  </div>
</template>

<script>
import util from "@/utils/util.js";
export default {
  name: "messageTip",
  props: {
    mesCount: {
      type: Boolean
    }
  },
  methods: {
    showMessage() {
      this.$router.push({
        name: "message_index"
      });
    }
  }
};
</script>
<style lang="less">
.item {
  // margin-top: 10px;
  // margin-right: 40px;
}
</style>